module.exports = __webpack_public_path__ + "img/unicorn.6cfdd2b4.png";